var map = {
	"./en.json": [
		2591,
		"src_app_shared_components_tec-file-input_i18n_en_json"
	],
	"./es.json": [
		3894,
		"src_app_shared_components_tec-file-input_i18n_es_json"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 9609;
module.exports = webpackAsyncContext;